module.exports = __webpack_public_path__ + "img/spider.93df7174.svg";